import {
  MOBILE_TEAM_MODAL_DEBUG_FEATURE,
  MOBILE_TEAM_MODAL_DEBUG_INSTANCE_ID,
  MobileModalDebugShell,
  MobileModalDebugSource,
} from '@/hooks/telemetry/mobile-modal-debug';
import {
  usePersistentDebugLogger,
  type PersistentDebugLogger,
} from '@/hooks/telemetry/use-persistent-debug-logger';
import { CSTRETCHMODAL_DEBUG_COMPONENT } from './Cstretchmodal.constants';

export function useCstretchmodalDebugLogger(): PersistentDebugLogger {
  return usePersistentDebugLogger({
    component: CSTRETCHMODAL_DEBUG_COMPONENT,
    instanceId: MOBILE_TEAM_MODAL_DEBUG_INSTANCE_ID,
    metadata: {
      feature: MOBILE_TEAM_MODAL_DEBUG_FEATURE,
      source: MobileModalDebugSource.Cstretchmodal,
      modalShell: MobileModalDebugShell.Stretch,
    },
  });
}
